import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'cs-grid-col',
    templateUrl: 'cs-grid-column.html',
    host: { 'class': 'grid-col' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsGridColumnComponent {
}
